import React from 'react'
import './GSTDetails.css'

const isYes = (val) =>
    val === 'yes' || val === 'Yes' || val === '1' || val === 1

const GSTDetails = ({ transporter_data }) => {
    const gst = transporter_data?.gst ?? 'Details not available'
    const hasGst = gst && gst !== 'Details not available'

    if (hasGst && isYes(gst.gst_registered)) {
        return (
            <div className="gstcard">
                <div className="gstcontainer row">
                    <div className="col-12">
                        <span className="data_header "><b>Goods and Services Tax(GST)</b></span>
                    </div>
                    <div className="col">
                        {isYes(gst.forward_charging_mechanism) ? (
                            <div className="gst"><b>Forward Charging Mechanism</b></div>
                        ) : (
                            <div className="gst"><b>Reverse Charging Mechanism</b></div>
                        )}
                        <div className="gst"><b>GST No: </b>{gst.gst_number}</div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="gstcard">
            <div className="gstcontainer row">
                <div className="col-12">
                    <span className="data_header padding-text"><b>Goods and Services Tax(GST)</b></span>
                </div>
                {!hasGst ? (
                    <div className="padding-text"><span>Details not available</span></div>
                ) : (
                    <div className="col">
                        <div className="gst"><span>Goods Transport Agency(GTA)</span></div>
                        <div className="gst">{gst.transportation_id}</div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default GSTDetails
